import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleDuplicateProject(
  state: State,
  { zone, project }: Boundaries["duplicateProject"]["success"],
): State {
  return state.map((res) =>
    res.zone.uuid === zone.uuid
      ? { ...res, projects: [project, ...res.projects] }
      : res,
  );
}

export { handleDuplicateProject };
